module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "px-3 py-2"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.err)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('h3', {
    staticClass: "pa-3"
  }, [_vm._v(_vm._s(_vm.$lang.labels.generalSettings))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [(!_vm.isLocalAdmin) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "rules": [function () { return _vm.selectedPlanet.length > 0 || ("" + (_vm.$lang.errors.missingPlanet)); }],
      "label": _vm.$lang.actions.selectPlanet,
      "items": _vm.mappedPlanets,
      "loading": _vm.planetLoading,
      "readonly": _vm.isEdit,
      "disabled": _vm.planets.length === 0
    },
    model: {
      value: (_vm.selectedPlanet),
      callback: function($$v) {
        _vm.selectedPlanet = $$v
      },
      expression: "selectedPlanet"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLocalAdmin) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "rules": [function () { return _vm.selectedCompany.length > 0 || ("" + (_vm.$lang.errors.missingCompany)); }],
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "loading": _vm.companyLoading,
      "readonly": _vm.isEdit,
      "disabled": _vm.companies.length === 0
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "py-2": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.externalIDres,
      "readonly": ""
    },
    model: {
      value: (_vm.externalResID),
      callback: function($$v) {
        _vm.externalResID = $$v
      },
      expression: "externalResID"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": _vm.isEdit,
      "md7": !_vm.isEdit,
      "py-2": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.webshopUrl,
      "rules": [function (v) { return _vm.validURL(v) || ("" + (_vm.$lang.errors.notValidUrl)); }, function (v) { return _vm.checkIsJustHostname(v) || ("" + (_vm.$lang.errors.notValidUrl)); }]
    },
    model: {
      value: (_vm.webshopUrl),
      callback: function($$v) {
        _vm.webshopUrl = $$v
      },
      expression: "webshopUrl"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "multiple": "",
      "required": "",
      "rules": [function () { return _vm.orderSubmissionAllowedFrom.length > 0 || ("" + (_vm.$lang.errors.missingOrderSubmission)); }],
      "label": _vm.$lang.labels.orderSubmission,
      "items": _vm.ordersFrom,
      "loading": _vm.orderSubmissionLoading,
      "chips": "",
      "deletable-chips": ""
    },
    model: {
      value: (_vm.orderSubmissionAllowedFrom),
      callback: function($$v) {
        _vm.orderSubmissionAllowedFrom = $$v
      },
      expression: "orderSubmissionAllowedFrom"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "rules": [function () { return _vm.selectedOrder.length > 0 || ("" + (_vm.$lang.errors.missingOrder)); }],
      "label": _vm.$lang.actions.selectOrderType,
      "chips": "",
      "deletable-chips": "",
      "multiple": "",
      "items": _vm.orderTypes
    },
    model: {
      value: (_vm.selectedOrder),
      callback: function($$v) {
        _vm.selectedOrder = $$v
      },
      expression: "selectedOrder"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "rules": [function () { return _vm.selectedPayment.length > 0 || ("" + (_vm.$lang.errors.missingPayment)); }],
      "label": _vm.$lang.actions.selectPayment,
      "chips": "",
      "deletable-chips": "",
      "multiple": "",
      "items": _vm.payments
    },
    model: {
      value: (_vm.selectedPayment),
      callback: function($$v) {
        _vm.selectedPayment = $$v
      },
      expression: "selectedPayment"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "px-3": "",
      "pb-0": "",
      "pt-2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "disabled": _vm.selectedPayment.length === 0,
      "rules": [function (value) { return !!value || 'Required'; }],
      "label": _vm.$lang.labels.defaultPaymentType,
      "items": _vm.selectedPayment.length === 0 ? [] : _vm.selectedPayment
    },
    model: {
      value: (_vm.defaultPaymentType),
      callback: function($$v) {
        _vm.defaultPaymentType = $$v
      },
      expression: "defaultPaymentType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "px-3": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang.labels.webshopQr))]), _vm._v(" "), (_vm.webshopUrl && _vm.externalResID) ? _c('qrcode-vue', {
    staticStyle: {
      "margin-top": "4px"
    },
    attrs: {
      "value": _vm.webshopQrCode,
      "level": "Q"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "px-3": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang.labels.contactTrackingQr))]), _vm._v(" "), (_vm.webshopUrl) ? _c('qrcode-vue', {
    staticStyle: {
      "margin-top": "4px"
    },
    attrs: {
      "value": _vm.contactTrackingQrCode,
      "level": "Q"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "px-3": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang.labels.menuQr))]), _vm._v(" "), (_vm.webshopUrl) ? _c('qrcode-vue', {
    staticStyle: {
      "margin-top": "4px"
    },
    attrs: {
      "value": _vm.menuQrCode,
      "level": "Q"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "rules": [function () { return _vm.selectedCatalogVersion !== null || ("" + (_vm.$lang.errors.missingCatalogVersion)); }],
      "label": _vm.$lang.actions.selectCatalogVersion,
      "items": _vm.mappedCatalogVersions,
      "disabled": _vm.catalogVersions.length === 0,
      "loading": _vm.catalogVersionsLoading
    },
    model: {
      value: (_vm.selectedCatalogVersion),
      callback: function($$v) {
        _vm.selectedCatalogVersion = $$v
      },
      expression: "selectedCatalogVersion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "rules": [function () { return _vm.selectedSubscription !== null || ("" + (_vm.$lang.errors.missingSubscription)); }],
      "label": _vm.$lang.actions.selectSubscription,
      "items": _vm.subscriptions
    },
    model: {
      value: (_vm.selectedSubscription),
      callback: function($$v) {
        _vm.selectedSubscription = $$v
      },
      expression: "selectedSubscription"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "rules": [function () { return _vm.selectedCatalogView !== null || ("" + (_vm.$lang.errors.missingCatalogView)); }],
      "label": _vm.$lang.actions.selectCatalogView,
      "items": _vm.mappedCatalogViews,
      "disabled": _vm.catalogViews.length === 0,
      "loading": _vm.catalogViewsLoading
    },
    model: {
      value: (_vm.selectedCatalogView),
      callback: function($$v) {
        _vm.selectedCatalogView = $$v
      },
      expression: "selectedCatalogView"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "required": "",
      "rules": [function () { return _vm.name.length > 0 || ("" + (_vm.$lang.errors.missingName)); }],
      "label": _vm.$lang.labels.name
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "required": "",
      "rules": [function () { return _vm.minDelivery != null || ("" + (_vm.$lang.errors.missingDeliery)); }],
      "label": _vm.$lang.labels.minDelivery,
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.minDelivery),
      callback: function($$v) {
        _vm.minDelivery = $$v
      },
      expression: "minDelivery"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.deliveryDurationFrom,
      "type": "number",
      "required": "",
      "rules": [function (v) { return v >= 0 && v <= 120 || ("" + (_vm.$lang.errors.timeError)); }],
      "min": "0",
      "max": "120"
    },
    model: {
      value: (_vm.deliveryDurationFrom),
      callback: function($$v) {
        _vm.deliveryDurationFrom = $$v
      },
      expression: "deliveryDurationFrom"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.deliveryDurationTo,
      "type": "number",
      "required": "",
      "rules": [function (v) { return v >= 0 && v <= 120 || ("" + (_vm.$lang.errors.timeError)); }],
      "min": "0",
      "max": "120"
    },
    model: {
      value: (_vm.deliveryDurationTo),
      callback: function($$v) {
        _vm.deliveryDurationTo = $$v
      },
      expression: "deliveryDurationTo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mx-0",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.sendToMoon
    },
    model: {
      value: (_vm.sendToMoon),
      callback: function($$v) {
        _vm.sendToMoon = $$v
      },
      expression: "sendToMoon"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-0",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.notifyOwnerOnPaymentFailure
    },
    model: {
      value: (_vm.notifyOwnerOnPaymentFailure),
      callback: function($$v) {
        _vm.notifyOwnerOnPaymentFailure = $$v
      },
      expression: "notifyOwnerOnPaymentFailure"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-0",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.acceptingOrders
    },
    model: {
      value: (_vm.acceptingOrders),
      callback: function($$v) {
        _vm.acceptingOrders = $$v
      },
      expression: "acceptingOrders"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mx-0",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.showEmail
    },
    model: {
      value: (_vm.showEmail),
      callback: function($$v) {
        _vm.showEmail = $$v
      },
      expression: "showEmail"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-0",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.showPhoneNumber
    },
    model: {
      value: (_vm.showPhoneNumber),
      callback: function($$v) {
        _vm.showPhoneNumber = $$v
      },
      expression: "showPhoneNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('h3', {
    staticClass: "pa-3"
  }, [_vm._v(_vm._s(_vm.$lang.labels.smsSettings))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mx-0 pb-2",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.smsConfirmationFirstOrder
    },
    model: {
      value: (_vm.smsConfirmationFirstOrder),
      callback: function($$v) {
        _vm.smsConfirmationFirstOrder = $$v
      },
      expression: "smsConfirmationFirstOrder"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": _vm.$lang.placeholders.smsUsername,
      "label": _vm.$lang.labels.smsUsername
    },
    model: {
      value: (_vm.smsUsername),
      callback: function($$v) {
        _vm.smsUsername = $$v
      },
      expression: "smsUsername"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pt-2": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang.labels.passwordSmaResetPrefixText))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.passwordSmsButtonDisabled,
      "color": "primary mx-0"
    },
    on: {
      "click": function($event) {
        _vm.isSms = true;
        _vm.updatePassword = true
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.updateSmsPassword) + "\n          ")])], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('h3', {
    staticClass: "pa-3"
  }, [_vm._v(_vm._s(_vm.$lang.labels.discountSettings))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.actions.selectRules,
      "chips": "",
      "deletable-chips": "",
      "multiple": "",
      "items": _vm.mappedDiscountRules,
      "disabled": _vm.mappedDiscountRules.length === 0
    },
    model: {
      value: (_vm.rules),
      callback: function($$v) {
        _vm.rules = $$v
      },
      expression: "rules"
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('h3', {
    staticClass: "pa-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.emailConf))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "required": "",
      "placeholder": _vm.$lang.placeholders.emailId,
      "rules": [function () { return _vm.sendEmail.length > 0 || ("" + (_vm.$lang.errors.missingEmailID)); }],
      "label": _vm.$lang.labels.sendEmail
    },
    model: {
      value: (_vm.sendEmail),
      callback: function($$v) {
        _vm.sendEmail = $$v
      },
      expression: "sendEmail"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "auto-grow": "",
      "rows": "1",
      "placeholder": _vm.$lang.placeholders.bccEmail,
      "label": _vm.$lang.labels.sendBCC
    },
    model: {
      value: (_vm.bccEmail),
      callback: function($$v) {
        _vm.bccEmail = $$v
      },
      expression: "bccEmail"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "auto-grow": "",
      "rows": "3",
      "label": _vm.$lang.labels.prefix
    },
    model: {
      value: (_vm.prefix),
      callback: function($$v) {
        _vm.prefix = $$v
      },
      expression: "prefix"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "auto-grow": "",
      "rows": "3",
      "label": _vm.$lang.labels.postfix
    },
    model: {
      value: (_vm.postfix),
      callback: function($$v) {
        _vm.postfix = $$v
      },
      expression: "postfix"
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "pa-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.paymentGatewaySettings))])]), _vm._v(" "), (_vm.isEdit && _vm.webshopStatus !== 'created') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.labels.payGateway,
      "items": _vm.gateways
    },
    model: {
      value: (_vm.selectedGateway),
      callback: function($$v) {
        _vm.selectedGateway = $$v
      },
      expression: "selectedGateway"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit && _vm.webshopStatus === 'created') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "px-3": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang.labels.activateShopFirst))])]) : _vm._e()], 1), _vm._v(" "), (['paymentsense', 'firstdata', 'connect-e', 'tecs'].includes(_vm.selectedGateway) && _vm.webshopStatus !== 'created') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [(_vm.selectedGateway === 'paymentsense' || _vm.selectedGateway === 'tecs') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.merchantId,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingMerchantId)); }],
      "required": ""
    },
    model: {
      value: (_vm.merchantId),
      callback: function($$v) {
        _vm.merchantId = $$v
      },
      expression: "merchantId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedGateway === 'paymentsense') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.preSharedKey,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingPreSharedKey)); }],
      "required": ""
    },
    model: {
      value: (_vm.preSharedKey),
      callback: function($$v) {
        _vm.preSharedKey = $$v
      },
      expression: "preSharedKey"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedGateway === 'firstdata') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.storeId,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingStoreId)); }],
      "required": ""
    },
    model: {
      value: (_vm.firstDataStoreId),
      callback: function($$v) {
        _vm.firstDataStoreId = $$v
      },
      expression: "firstDataStoreId"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedGateway === 'connect-e') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.connectEApiKey,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingApiKey)); }],
      "required": ""
    },
    model: {
      value: (_vm.connectEApiKey),
      callback: function($$v) {
        _vm.connectEApiKey = $$v
      },
      expression: "connectEApiKey"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedGateway === 'connect-e') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.connectEUsername,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingUsernameP)); }],
      "required": ""
    },
    model: {
      value: (_vm.connectEUsername),
      callback: function($$v) {
        _vm.connectEUsername = $$v
      },
      expression: "connectEUsername"
    }
  })], 1) : _vm._e(), _vm._v(" "), [_c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pt-2": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang.labels.passwordResetPrefixText))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.passwordButtonDisabled,
      "color": "primary mx-0"
    },
    on: {
      "click": function($event) {
        _vm.updatePassword = true
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$lang.labels.updatePassword) + "\n            ")])], 1)]], 2) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('h3', {
    staticClass: "pa-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.htmlHints))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary mx-0"
    },
    on: {
      "click": function($event) {
        return _vm.addHtmlCode()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.addHtml) + "\n          ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary mx-0"
    },
    on: {
      "click": function($event) {
        _vm.htmlImportModal = true
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.importHtml) + "\n          ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-3": ""
    }
  }, [(_vm.htmlHints) ? _c('v-data-table', {
    staticClass: "elevation-0 mt-2",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.htmlHints,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), (props.item.name !== 'webshop.logo' && props.item.name !== 'webshop.headerImage.mobile') ? _c('td', [_vm._v("\n                " + _vm._s(props.item.value) + "\n              ")]) : _c('td', [_c('v-img', {
          attrs: {
            "src": props.item.value,
            "contain": "",
            "max-height": "60"
          }
        })], 1), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "primary mx-0",
          on: {
            "click": function($event) {
              return _vm.editHtmlCode(props.item)
            }
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.$lang.actions.edit) + "\n                ")]), _vm._v(" "), _c('v-btn', {
          staticClass: "error mx-0",
          on: {
            "click": function($event) {
              return _vm.confirmDeleteHtmlCode(props.item)
            }
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.$lang.actions.delete) + "\n                ")])], 1)]
      }
    }], null, false, 3541464929)
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isEdit) ? [_c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.created,
      "type": "text"
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.modified,
      "type": "text"
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  })], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.err)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": "",
      "py-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'webShop'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.actions.submit) + "\n        ")])], 1)], 2)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "bottom": "",
      "timeout": _vm.snackbarTimeout,
      "color": "error",
      "multi-line": ""
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$lang.labels.sendToMoonWarning) + "\n    "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$lang.actions.close) + "\n    ")])], 1), _vm._v(" "), (_vm.activationModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.activationModal),
      callback: function($$v) {
        _vm.activationModal = $$v
      },
      expression: "activationModal"
    }
  }, [_c('activation-modal', {
    attrs: {
      "data": _vm.activationData
    },
    on: {
      "close": function($event) {
        return _vm.redirectBack()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.updatePassword) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.updatePassword),
      callback: function($$v) {
        _vm.updatePassword = $$v
      },
      expression: "updatePassword"
    }
  }, [_c('change-password', {
    attrs: {
      "isSms": _vm.isSms
    },
    on: {
      "close": function($event) {
        _vm.updatePassword = false;
        _vm.isSms = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.confirmationModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.confirmationModal),
      callback: function($$v) {
        _vm.confirmationModal = $$v
      },
      expression: "confirmationModal"
    }
  }, [_c('confirmation-modal', {
    attrs: {
      "text": _vm.$lang.actions.deleteHtmlHint
    },
    on: {
      "submit": function($event) {
        return _vm.deleteHtmlCode()
      },
      "close": function($event) {
        _vm.confirmationModal = false;
        _vm.tempIndex = null
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.htmlModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "1200"
    },
    model: {
      value: (_vm.htmlModal),
      callback: function($$v) {
        _vm.htmlModal = $$v
      },
      expression: "htmlModal"
    }
  }, [_c('html-hints-modal', {
    attrs: {
      "htmlCode": _vm.htmlCodeToEdit,
      "isHtmlEdit": _vm.isHtmlEdit,
      "htmlKeysListFiltered": _vm.htmlKeysListFiltered
    },
    on: {
      "submit": function($event) {
        return _vm.saveHtmlCode($event)
      },
      "close": function($event) {
        _vm.htmlModal = false, _vm.htmlCodeToEdit = null, _vm.tempIndex = null
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.htmlImportModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "1200"
    },
    model: {
      value: (_vm.htmlImportModal),
      callback: function($$v) {
        _vm.htmlImportModal = $$v
      },
      expression: "htmlImportModal"
    }
  }, [_c('html-hints-import-modal', {
    on: {
      "submit": function($event) {
        return _vm.importHtmlCode($event)
      },
      "close": function($event) {
        _vm.htmlImportModal = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74f9e377","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/webShop/WebShopDetail.vue
// module id = 418
// module chunks = 35